﻿import { writable } from 'svelte/store';

export const pageList = writable(null);
export const currentPage = writable(0);
export const pageNumber = writable(0);
